import type * as lazyIndex from "./lazyIndex";
import { type LazyComponent, LazyModule, createLazyComponent } from "owa-bundling";
import type { MailboxInfo } from "owa-client-types";

export { showResourceTokenAuthInfoBarMutator } from "./actions/showResourceTokenAuthInfoBar";
export { hasResourceTokenAuthInfoBarRequest } from "./hasResourceTokenAuthInfoBarRequest";
export type { ResourceTokenAuthInfoBarRequest } from "./utils/getResourceTokenAuthInfoBarRequestKey";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "ResourceTokenAuthInfoBar" */ "./lazyIndex"), { name: "ResourceTokenAuthInfoBar" });

export const ResourceTokenAuthInfoBarHost: LazyComponent<{
    mailboxInfo: MailboxInfo;
}, unknown, void> = createLazyComponent(lazyModule, m => m.ResourceTokenAuthInfoBarHost);
